import { useEffect } from 'react';
import { Stack, Switch, Text } from '@mantine/core';
import ConfigOption from '../../../Atoms/ConfigOption';
import PanePaper from '../../../Molecules/PanePaper';
import { useResourceModuleVisibility } from '../../../Service/hooks/useResourceModuleVisibility';
import ResourceCategoriesList from './ResourceCategoriesList';

const ResourcesPane = () => {
  const [hideResourceModule, setHideResourceModule] = useResourceModuleVisibility();

  useEffect(() => {
    document.title = 'Ressourcen';
  }, []);

  return (
    <PanePaper title="Ressourcen">
      <Stack>
        <Text>Individualisiere die Art, wie Du Deine Ressourcen in bookitup verwaltest.</Text>
        <ConfigOption
          py="sm"
          title="Ressourcen-Modul in Navigation ausblenden"
          description="Blendet den Ressourcen-Menüpunkt in der Hauptnavigation aus. Das Modul und diese Einstellungen bleiben weiterhin erreichbar."
          rightSection={
            <Switch
              aria-label="Ressourcen-Modul in Navigation ausblenden"
              checked={hideResourceModule}
              onChange={(event) => setHideResourceModule(event.currentTarget.checked)}
            />
          }
        />
        {/* <ResourceStandardElements /> */}
        <ResourceCategoriesList />
      </Stack>
    </PanePaper>
  );
};

export default ResourcesPane;
